/**
 * Settings hub — /(app)/settings
 *
 * Central landing page for all user-self-related actions. Reached from the
 * lobby cog; its shared action list is also rendered in the in-game modal.
 */

import React from 'react'
import { View, ScrollView, useWindowDimensions } from 'react-native'
import { useRouter } from 'expo-router'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useOrientation } from '../../../hooks/useOrientation'
import { SettingsHubContent } from '../../../components/settings/SettingsHubContent'
import { ScreenHeader } from '../../../components/ui/ScreenHeader'

export default function SettingsHubScreen() {
  const router = useRouter()
  const { width: winWidth } = useWindowDimensions()
  const { isLandscape } = useOrientation()
  const contentWidth = isLandscape ? Math.min(560, winWidth * 0.6) : undefined

  return (
    <SafeAreaView className="flex-1 bg-canvas">
      {/* Header. "Back to lobby" is the label the Maestro login fixture taps. */}
      <ScreenHeader
        title="Settings"
        icon="cog"
        onBack={() => router.replace('/(app)')}
        backLabel="Back to lobby"
      />

      <ScrollView
        className="flex-1"
        contentContainerStyle={{
          padding: 16,
          gap: 16,
          alignItems: isLandscape ? 'center' : undefined,
        }}
      >
        <View style={isLandscape ? { width: contentWidth } : { width: '100%' }}>
          <SettingsHubContent />
        </View>
      </ScrollView>
    </SafeAreaView>
  )
}
